import { gql } from '@nerdwallet/apollo';

const creditCardRewardFragment = `
  id
  shoppingFinishedId
  shoppingFinishedAt
  marketplaceInstitutionId
  marketplaceProductId
  marketplaceOfferId
  marketplaceCreditCardOffer {
    id
    name
    status
  }
  nwPlusActivationStatus
  accountId
  accountLinkedAt
  fdpAccount {
    id
    name
    type
    subtype
  }
  events {
    id
    eventType
    emittedAt
    viewedAt
    pointsRewarded
  }
`;

const bankingRewardFragment = `
  id
  shoppingFinishedId
  shoppingFinishedAt
  marketplaceInstitutionId
  marketplaceProductId
  marketplaceOfferId
  marketplaceBankingOffer {
    id
    name
    status
  }
  nwPlusActivationStatus
  accountId
  accountLinkedAt
  fdpAccount {
    id
    name
    type
    subtype
  }
  events {
    id
    eventType
    emittedAt
    viewedAt
    pointsRewarded
  }
`;

const UPDATE_REWARD_AS_DISMISSED = gql`
  mutation updateFinancialNwPlusRewardDismissed(
    $id: ID!
  ) {
    updateFinancialNwPlusRewardDismissed(id: $id) {
      creditCard {
        ${creditCardRewardFragment}
      }
      bankingAccount {
        ${bankingRewardFragment}
      }
    }
  }
`;

export default UPDATE_REWARD_AS_DISMISSED;
